import { LogsBase } from "~/areas/configuration/components/Diagnostics/Logs/LogsBase";

export class AutoDeployLogs extends LogsBase {
    constructor(props: {}) {
        super("ProcessAutoDeployments", "Auto Deploy Logs", props);
    }
}

export default AutoDeployLogs;
